// extracted by mini-css-extract-plugin
export default {"firm-card":"firm-card--fteY","actions":"actions--eUfZ","boards":"boards--8tTd","scrolls":"scrolls--8eHH","action":"action--7noA","contacts":"contacts--q1pR"};